// @ts-ignore
import React from "react";

import { JiraSoftwarePageTemplatePaidLpJswFeatures } from "../../templates/jira-software-page/src";

export const JiraSoftwarePagePaidLpJswFeatures = () => (
    <JiraSoftwarePageTemplatePaidLpJswFeatures />
);
